import { Currency } from '@/constants';
import { isSolanaCurrency, isSplCurrency } from '@/utils';

import useChainByCurrency from './useChainByCurrency';

type ChainNamespace = 'eip155' | 'bip122' | 'solana';

function useReownNamespaceByCurrency(currency: Currency.BTC): 'bip122';
function useReownNamespaceByCurrency(currency: Currency.ETH): 'eip155';
function useReownNamespaceByCurrency(currency: Currency.SOL): 'solana';
function useReownNamespaceByCurrency(currency: Currency): ChainNamespace;
function useReownNamespaceByCurrency(currency: Currency): ChainNamespace {
  const { isEvm, isBtc, isSolana } = useChainByCurrency(currency);

  if (isSolana || isSolanaCurrency(currency) || isSplCurrency(currency)) {
    return 'solana';
  }

  const namespace: ChainNamespace = isEvm ? 'eip155' : isBtc ? 'bip122' : 'eip155';

  return namespace;
}

export default useReownNamespaceByCurrency;
